require('./cookie.coffee')

class window.CookieNotifier
  constructor: ->
    @notifierBlock = $('.cookie-notifier-block')
    @closeNotifyButton = $('#close-cookie-notify')
    @cookie = new window.Cookie()
    @cookieName = 'cookie_notify'
    @init()

  init: ->
    self = this
    
    cookie = @cookie.getCookie(@cookieName)
    if cookie == undefined && cookie != 'true'
      @notifierBlock.show()
    else
      @notifierBlock.hide()
    
    @closeNotifyButton.click ->
      self.cookie.setCookie(self.cookieName, 'true')
      self.notifierBlock.hide()


// WEBPACK FOOTER //
// ./assets/javascripts/app/cookie_notifier.coffee